import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

// const CategoryList = Loadable(lazy(() => import('./FeedbackList')));
const AddReview = Loadable(lazy(() => import('./AddReview')));

const ReviewRoutes = [
    {
        path: '/dashboard/addreview',
        element: <AddReview />,
        auth: authRoles.admin,
    },
];

export default ReviewRoutes;
